import {
  useCallback,
  useEffect,
  useRef,
  useState,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
} from "react";

export interface UseImageUploadResult {
  uploaded: boolean;
  uploading: boolean;
  file: File | null;
  preview: string | null;
  previewRef: MutableRefObject<string | null>;
  setUploaded: Dispatch<SetStateAction<boolean>>;
  setUploading: Dispatch<SetStateAction<boolean>>;
  setFile: Dispatch<SetStateAction<File | null>>;
  setPreview: Dispatch<SetStateAction<string | null>>;
  reset: () => void;
}

export function useImageUpload(): UseImageUploadResult {
  const [uploaded, setUploaded] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const previewRef = useRef<string | null>(null);
  previewRef.current = preview;

  const reset = useCallback(() => {
    setUploaded(false);
    setUploading(false);
    setFile(null);
    setPreview((prev) => {
      if (prev) {
        URL.revokeObjectURL(prev);
      }
      return null;
    });
  }, []);

  useEffect(() => {
    return () => {
      if (previewRef.current) {
        URL.revokeObjectURL(previewRef.current);
      }
    };
  }, []);

  return {
    uploaded,
    uploading,
    file,
    preview,
    previewRef,
    setUploaded,
    setUploading,
    setFile,
    setPreview,
    reset,
  };
}
